import Model from 'src/storage/base';
import { isAdminPage } from 'src/helpers';

class PatientDetailModel extends Model {
  id = 'PatientDetailModel';
  defaultState = () => ({
    patient: null,
    tab: 'appointment'
  });
  apiConfig = {
    patient_detail: {
      url: (isAdminPage() ? 'admin/' : '') + 'patient/detail',
      validation: {
        id: 'userId'
      },
      cancellable: true
    }
  };

  _events = {
    openPatient: 'onOpenPatient',
    profile: 'handleProfile'
  };
  handleProfile = (profile) => {
    this.setState({ user: profile });
  };

  onOpenPatient = (patient = null) => {
    this.setState({
      patient
    });
  };

  getPatient = () => {
    return this.state.patient;
  };

  loadDetail = (id, cb) => {
    this.setState({ patient: null });
    this.api('patient_detail', { id }, (error, patient, success) => {
      if (success) {
        this.emit('openPatient', patient);
      } else {
        cb();
      }
    });
  };
}

const model = new PatientDetailModel();
export default model;
